import { PosicaoCampoRelatorioGerencialEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'
import { createValidator, empty, maxLength, required } from 'util/validation'

import { visibilidadeModeloPersonalizadoEnumToIsPublico } from '../converter-modeloPersonalizadoRelatorioGerencial'
import { ModeloPersonalizadoRelatorioGerencialFormModel } from './model-modeloPersonalizadoRelatorioGerencialForm'

interface ModeloPersonalizadoRelatorioGerencialFormValidatorInput {
  hasFiltroCiapCid: boolean
  hasFiltroPeriodo: boolean
  hasFiltroTipoAgrupamento: boolean
  isModeloSalvoPublico?: boolean
}

export const modeloPersonalizadoRelatorioGerencialFormValidator = (
  input: ModeloPersonalizadoRelatorioGerencialFormValidatorInput
) => {
  const { hasFiltroCiapCid, hasFiltroPeriodo, hasFiltroTipoAgrupamento, isModeloSalvoPublico } = input
  return createValidator<ModeloPersonalizadoRelatorioGerencialFormModel>(
    {
      nome: [required, maxLength(255)],
      aggregatorModal: [required],
      modulo: [required],
    },
    (value, errors) => {
      if (hasFiltroPeriodo) {
        errors.opcaoSelecionadaModal = required(value.opcaoSelecionadaModal)
        errors.unidadePeriodoModal = required(value.unidadePeriodoModal)
      } else {
        errors.opcaoSelecionadaModal = empty(value.opcaoSelecionadaModal)
        errors.unidadePeriodoModal = empty(value.unidadePeriodoModal)
      }

      if (hasFiltroTipoAgrupamento) {
        errors.tipoAgrupamentoModal = required(value.tipoAgrupamentoModal)
      } else {
        errors.tipoAgrupamentoModal = empty(value.tipoAgrupamentoModal)
      }

      const hasNoColunaOrLinha =
        value.campos?.isEmpty() ||
        !value.campos?.some(
          ({ posicao }) =>
            posicao === PosicaoCampoRelatorioGerencialEnum.COLUNA ||
            posicao === PosicaoCampoRelatorioGerencialEnum.LINHA
        )

      const hasChangedVisibilidade =
        !isUndefinedOrNull(isModeloSalvoPublico) &&
        isModeloSalvoPublico !== visibilidadeModeloPersonalizadoEnumToIsPublico(value.visibilidade)

      if (!hasFiltroCiapCid) {
        errors.ciapsCids = empty(value.ciapsCids)
        errors.gruposCondicoes = empty(value.gruposCondicoes)
      }

      if (hasNoColunaOrLinha) {
        errors.campos = 'Obrigatório adicionar pelo menos uma coluna/linha.'
      }

      if (hasChangedVisibilidade) {
        errors.visibilidade = 'Não é possível editar a visibilidade.'
      }

      return errors
    }
  )
}
